import {
  Component, OnInit,
  Directive,
  ElementRef,
  Input,
} from '@angular/core';
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { ISalesContacts, Sales_contact__Model } from '../../interface/Backofficesale_Master'
import { LoyaltyService } from '../../../shared/services/Loyalty/loyalty.service'
import { InSalesService } from '../../../shared/services/inventory/in-sales.service'
import { ContactSearchComponent } from '../../../shared'
import { SalescontacthistoryComponent } from '../../../shared'
import { DataService } from '../../../shared/services/data.service'
export interface ContactModel {
  title: string;
  data: any;
}
@Component({
  selector: 'app-salescontact',
  templateUrl: './salescontact.component.html',
  styleUrls: ['./salescontact.component.css']
})

export class SalescontactComponent extends DialogComponent<ContactModel, boolean> implements ContactModel, OnInit {
  title: string;
  data: any = []
  fullData: any;
  salesContact: ISalesContacts
  ContactSearch: ISalesContacts
  nationality: any
  gender: any = []
  history: boolean = false
  saleshistory: any = []
  result: any = { result: false, RtnItem: {} };
  constructor(dialogService: DialogService, private sa: InSalesService, private Ls: LoyaltyService, private ds: DataService) { super(dialogService); }

  ngOnInit() {
    this.clear()
    // this.salesContact = new Sales_contact__Model()
    this.salesContact = this.data
    if (this.salesContact.Id != 0) {
      this.history = true
    }
    document.getElementById("phone").focus()

  }
  ok() {
    if (this.salesContact.PhoneNo == "" || this.salesContact.PhoneNo == null) {
      alert("Please enter Phone Number")
      document.getElementById("phone").focus()
    }
    else if (this.salesContact.Name == "" || this.salesContact.Name == null) {
      alert("Please enter Name")
      document.getElementById("name").focus()
    }
    else if (this.salesContact.Nationality == "" || this.salesContact.Nationality == null) {
      alert("Please select Nationality")
      document.getElementById("nationality").focus()
    }
    else if (this.salesContact.Gender == 0) {
      alert("Please select Gender")
      document.getElementById("gender").focus()
    }
    else {
      this.result.result = this.salesContact
      this.close()
    }
  }
  phoneKeyDown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      // this.phoneLeave();
      var no: any = {
        MobileNo: this.salesContact.PhoneNo
      }
      this.sa.getPOSContactByMobile(no).subscribe(res => {
        this.salesContact.Address = res.data.Address
        this.salesContact.PhoneNo = res.data.PhoneNo
        this.salesContact.Name = res.data.Name
        this.salesContact.DOB = res.data.DOB
        this.salesContact.Gender = res.data.Gender
        this.salesContact.Nationality = res.data.Nationality
        this.salesContact.Type = 2
        this.salesContact.LocId = res.data.LocId
        this.salesContact.Email = res.data.Email
        this.history = true
      })
      document.getElementById("name").focus()
    }

  }
  phoneLeave() {
    document.getElementById("name").focus()
  }
  nameKeyDown(e) {
    if (e.keyCode == 13 && e.which == 13) {

      this.nameLeave();
    }
  }
  nameLeave() {
    document.getElementById("nationality").focus()
  }
  emailKeyDown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.emailLeave();
    }
  }
  emailLeave() {
    document.getElementById("save").focus()
  }
  addressKeyDown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.addressLeave();
    }
  }
  addressLeave() {
    document.getElementById("email").focus()
  }
  clear() {
    this.salesContact = new Sales_contact__Model()
    this.ContactSearch = new Sales_contact__Model()
    this.salesContact.DOB = new Date
    this.gender = []
    this.history = false
    this.getNationality()
    this.getGender()
  }
  getNationality() {

    this.Ls.GetNationality().subscribe(res => {
      this.nationality = []
      if (res.Success) {
        for (let it of res.data) {
          this.nationality.push({ Id: it.Id, Name: it.Name })
        }
        this.salesContact.Nationality = this.nationality[0].Name
      }

    })
  }
  getNationalityChange(e) {
    this.salesContact.Nationality = e.Name
    document.getElementById("gender").focus()
  }
  getGender() {
    this.gender.push({ Id: 1, Name: "Male" }, { Id: 2, Name: "Female" })
    this.salesContact.Gender = this.gender[0].Id
  }
  getGenderChange(e) {
    this.salesContact.Gender = e.Id
    document.getElementById("dob").focus()
  }
  loadContact(type: boolean) {
    var filterdata: any = {
      Contact: {
        Name: "",
        Gender: "",
        PhoneNo: "",
        Address: "",
        Email: "",
        Nationality: ""
      },
      Filter: {
        Start: 0,
        FiterText: "",
        Limit: this.ds.Settings.MaxLimit,
        LocationId: this.ds.Settings.LocationId
      }
    }
    this.sa.getPOSContactSearch(filterdata).subscribe(res => {
      if (res.Success) {
        this.ContactSearch = res.data
        this.listContact();
      }
    }, (err) => { }, () => {
    });
  }
  listContact() {
    let d = this.dialogService
      .addDialog(ContactSearchComponent, { title: "search", data: this.ContactSearch })
      .subscribe(res => {
        if (res.result) {
          this.ContactSearch = res.item;
          this.ContactSearch.Address = res.item.Address
          this.ContactSearch.PhoneNo = res.item.PhoneNo
          this.ContactSearch.Name = res.item.Name
          this.ContactSearch.DOB = new Date
          this.ContactSearch.DOB = this.ContactSearch.DOB
          if (res.item.Gender == "Male") {
            this.ContactSearch.Gender = 1
          } else if (res.item.Gender == "Female") {
            this.ContactSearch.Gender = 2
          }
          this.ContactSearch.Nationality = res.item.Nationality
          this.ContactSearch.Type = 2
          this.ContactSearch.LocId = this.ds.Settings.LocationId
          this.ContactSearch.Email = res.item.Email
          this.salesContact = this.ContactSearch
          this.history = true
        }
        else {
          this.ContactSearch = this.ContactSearch
        }
      });
  }
  dobLeave() {
    document.getElementById("address").focus()
  }
  dobKeyDown(e) {
    if (e.keyCode == 13 && e.which == 13) {
      this.dobLeave();
    }
  }
  loadHistory() {
    var filter: any = {
      PhoneNo: this.salesContact.PhoneNo,
      RequestedList: {
        Start: 0,
        FiterText: "",
        Limit: this.ds.Settings.MaxLimit,
        ItemTypeId: this.ds.Settings.ItemTypeId,
        CAType: this.ds.Settings.CAType
      }
    }
    this.sa.getSalescontactHistory(filter).subscribe(res => {
      if (res.Success) {
        this.saleshistory = res.data
      }
      let d = this.dialogService
        .addDialog(SalescontacthistoryComponent, { title: "Bill History", data: this.saleshistory })
        .subscribe(res => {

        });

    })
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/salescontact/salescontact.component.ts